import { useQuery } from '@tanstack/react-query';
import { settingApi } from '../api/settingApi';

/**
 * GET /api/eraf/system-settings/categories
 * queryKey: ['system-settings', 'categories', locale]
 */
export function useCategories(locale = 'ko') {
  return useQuery({
    queryKey: ['system-settings', 'categories', locale],
    queryFn: () => settingApi.getCategories(locale),
    staleTime: 5 * 60_000, // category labels rarely change
  });
}
